import { XMarkIcon } from "@heroicons/react/24/outline";
import "./Modals.css";
import SimpleCombobox from "../../components/SimpleCombobox";
import { useState } from "react";
import api from "../../api";

export const ModalAlert = (props) => {
    const closeDialog = () => {
        props.dialogRef.current?.close();
    };

    return (
        <div
            className={`alert overflow-auto ${
                props.type === "stock" && "orange"
            } ${props.type === "expiration" && "red"}`}
        >
            <div className="flex justify-between items-center">
                <h2 className="text-gray-800 text-2xl font-bold">
                    {props.title}
                </h2>
                <button
                    className="hover:bg-white hover:bg-opacity-50 p-1 rounded transition-all"
                    onClick={closeDialog}
                >
                    <XMarkIcon className="h-6 w-6" />
                </button>
            </div>
            {props.subTitle && <h4 className="font-bold">{props.subTitle}</h4>}
            {props.list && (
                <ul className="mt-4">
                    {props.list.map((item, index) => (
                        //cambiar la key por algo de la repuesta
                        <li
                            key={`${index}-${item.supply}`}
                            className="flex mt-3 pb-2 justify-between border-b border-b-black"
                        >
                            <span>{item.supply}</span>
                            <span>{item.stock || item.expiration}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

const movementActions = {
    add_total: { label: "Agregar a stock total", method: "addTotal" },
    assign_to_or: { label: "Asignar a quirófano", method: "assignToOr" },
    consume_or: { label: "Consumir en quirófano", method: "consumeOr" },
    return_from_or: {
        label: "Devolver a stock total",
        method: "returnFromOr",
    },
};

export const MoveStockModal = (props) => {
    const availableActions = props.restrictToOrActions
        ? { consume_or: movementActions.consume_or, return_from_or: movementActions.return_from_or }
        : movementActions;
    const [action, setAction] = useState(
        props.restrictToOrActions ? "consume_or" : "add_total"
    );
    const [quantity, setQuantity] = useState("");
    const [notes, setNotes] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const closeDialog = () => {
        setQuantity("");
        setNotes("");
        setError("");
        props.dialogRef.current?.close();
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!quantity || Number(quantity) <= 0) {
            setError("Ingresá una cantidad válida");
            return;
        }
        setError("");
        setLoading(true);
        try {
            const method = availableActions[action].method;
            const { supply } = await api.supplies[method](props.supply.id, {
                quantity: Number(quantity),
                notes,
            });
            props.setSupplies((prev) =>
                prev.map((s) => (s.id === supply.id ? supply : s))
            );
            closeDialog();
        } catch (e) {
            setError(e.detail || "Hubo un error al mover el stock");
        } finally {
            setLoading(false);
        }
    };

    return (
        <form className="alert" onSubmit={handleSubmit}>
            <div className="flex justify-between items-center">
                <h2 className="text-gray-800 text-2xl font-bold">
                    Mover stock {props.supply?.category ? `— ${props.supply.category}` : ""}
                </h2>
                <button
                    type="button"
                    className="hover:bg-black hover:bg-opacity-10 p-1 rounded transition-all"
                    onClick={closeDialog}
                >
                    <XMarkIcon className="h-6 w-6" />
                </button>
            </div>
            <div className="mt-5 flex flex-col gap-4">
                <div>
                    <label className="block text-sm font-medium leading-6 text-gray-900">
                        Movimiento
                    </label>
                    <select
                        value={action}
                        onChange={(e) => setAction(e.target.value)}
                        className="shadow-sm pl-2 mt-1 w-full bg-white border border-gray-300 focus:ring-primary focus:border-primary sm:text-sm rounded-md"
                    >
                        {Object.entries(availableActions).map(([key, { label }]) => (
                            <option key={key} value={key}>
                                {label}
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <label className="block text-sm font-medium leading-6 text-gray-900">
                        Cantidad
                    </label>
                    <input
                        type="number"
                        min="1"
                        value={quantity}
                        onChange={(e) => setQuantity(e.target.value)}
                        className="shadow-sm pl-2 mt-1 w-full bg-white border border-gray-300 focus:ring-primary focus:border-primary sm:text-sm rounded-md"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium leading-6 text-gray-900">
                        Notas
                    </label>
                    <textarea
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        className="shadow-sm pl-2 mt-1 w-full bg-white border border-gray-300 focus:ring-primary focus:border-primary sm:text-sm rounded-md"
                    />
                </div>
                {error && <p className="text-sm text-red-600">{error}</p>}
            </div>
            <button
                type="submit"
                disabled={loading}
                className="w-full mt-6 flex justify-center items-center px-4 py-2 border border-transparent shadow-sm text-sm font-semibold rounded-md text-white bg-primary hover:bg-primary disabled:opacity-50"
            >
                {loading ? "Guardando..." : "Confirmar"}
            </button>
        </form>
    );
};

const supplyTypeOptions = [
    { value: "single_use", label: "Único uso" },
    { value: "reusable", label: "Reutilizable" },
    { value: "resterilizable", label: "Resterilizable" },
    { value: "other", label: "Otro" },
];

export const NewSupplieForm = (props) => {
    const [newSupplie, setNewSupplie] = useState({
        category: null,
        supplyType: "",
        minStock: null,
        stock: null,
        unitCost: null,
        brand: null,
        maxUses: null,
        expirationDate: null,
    });
    const [formErrors, setFormErrors] = useState({
        category: false,
        supplyType: false,
        minStock: false,
        expirationDate: false,
        stock: false,
        unitCost: false,
        brand: false,
    });
    const closeDialog = () => {
        props.dialogRef.current?.close();
    };

    const handleChange = (field, value) => {
        const parsedValue =
            field === "expirationDate" && value === ""
                ? null
                : typeof value === "object" && value !== null
                  ? value.id
                  : value;
        setNewSupplie((prev) => ({
            ...prev,
            [field]: parsedValue,
        }));
        setFormErrors({ ...formErrors, [field]: false });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const newErrors = {
            category: !newSupplie.category && "Este campo es obligatorio",
            supplyType: !newSupplie.supplyType && "Este campo es obligatorio",
            minStock: !newSupplie.minStock && "Este campo es obligatorio",
            stock: !newSupplie.stock && "Este campo es obligatorio",
            unitCost: !newSupplie.unitCost && "Este campo es obligatorio",
        };
        setFormErrors(newErrors);
        const hasErrors = Object.values(newErrors).some((e) => e);
        if (hasErrors) return;

        try {
            const response = await api.supplies.create(newSupplie);

            props.setSupplies((prev) => [...prev, response]);
            props.dialogRef.current?.close();
        } catch (error) {
            console.error("Error al agerar el nuevo insumo:", error);
            alert("Hubo un error al guardar el insumo. Inténtalo nuevamente.");
        }
    };

    const createCategory = async (newItem) => {
        const response = await api.categories.create(newItem);
        props.setCategories((prev) => [...prev, response]);
        return response;
    };

    const createBrand = async (newItem) => {
        const response = await api.brands.create(newItem);
        props.setBrands((prev) => [...prev, response]);
        return response;
    };

    return (
        <form className={`alert`} onSubmit={handleSubmit}>
            <div className="flex justify-between items-center">
                <h2 className="text-gray-800 text-2xl font-bold">
                    Nuevo Insumo
                </h2>
                <button
                    type="button"
                    className="hover:bg-black hover:bg-opacity-10 p-1 rounded transition-all"
                    onClick={closeDialog}
                >
                    <XMarkIcon className="h-6 w-6" />
                </button>
            </div>
            <div className="modal-input-grid mt-5">
                <SimpleCombobox
                    inputClassName="relative"
                    placeholder={"Escribe el nombre..."}
                    handleChange={handleChange}
                    name="category"
                    label="Nombre del insumo"
                    className="shadow-sm pl-2 mt-1 w-full bg-white border border-gray-300 focus:ring-primary focus:border-primary block sm:text-sm rounded-md"
                    options={props.categories}
                    create={createCategory}
                    required={true}
                    error={formErrors.category}
                />
                <div>
                    <label
                        htmlFor="supplyType"
                        className="block text-sm font-medium leading-6 text-gray-900"
                    >
                        Tipo de insumo
                        <span className="font-medium text-[#F51515] ml-2">
                            *
                        </span>
                    </label>
                    <select
                        name="supplyType"
                        id="supplyType"
                        value={newSupplie.supplyType}
                        onChange={(e) =>
                            handleChange("supplyType", e.target.value)
                        }
                        className={`shadow-sm pl-2 w-full bg-white border ${
                            formErrors.supplyType
                                ? "border-red-500"
                                : "border-gray-300"
                        } focus:ring-primary focus:border-primary sm:text-sm rounded-md block`}
                    >
                        <option value="" hidden>
                            Selecciona el tipo
                        </option>
                        {supplyTypeOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    {formErrors.supplyType && (
                        <p className="mt-2 text-sm text-red-600">
                            {formErrors.supplyType}
                        </p>
                    )}
                </div>
                {["reusable", "resterilizable"].includes(
                    newSupplie.supplyType
                ) && (
                    <div>
                        <label
                            htmlFor="maxUses"
                            className="block text-sm font-medium leading-6 text-gray-900"
                        >
                            Usos máximos esperados
                        </label>
                        <input
                            type="number"
                            placeholder="Opcional"
                            name="maxUses"
                            id="maxUses"
                            value={newSupplie.maxUses || ""}
                            onChange={(e) =>
                                handleChange("maxUses", e.target.value)
                            }
                            className="shadow-sm pl-2 w-full bg-white border border-gray-300 focus:ring-primary focus:border-primary sm:text-sm rounded-md block"
                        />
                    </div>
                )}
                <div>
                    <label
                        htmlFor="minStock"
                        className="block text-sm font-medium leading-6 text-gray-900"
                    >
                        Stock mínimo
                        <span className="font-medium text-[#F51515] ml-2">
                            *
                        </span>
                    </label>
                    <input
                        type="number"
                        placeholder="Escribe el stock minimo..."
                        name="minStock"
                        id="minStock"
                        value={newSupplie.minStock}
                        onChange={(e) =>
                            handleChange("minStock", e.target.value)
                        }
                        className={`shadow-sm pl-2 w-full bg-white border ${
                            formErrors.minStock
                                ? "border-red-500"
                                : "border-gray-300"
                        } focus:ring-primary focus:border-primary sm:text-sm rounded-md block`}
                    />
                    {formErrors.minStock && (
                        <p className="mt-2 text-sm text-red-600">
                            {formErrors.minStock}
                        </p>
                    )}
                </div>
                <div>
                    <label
                        htmlFor="expirationDate"
                        className="block text-sm font-medium leading-6 text-gray-900"
                    >
                        Fecha de vencimiento
                    </label>
                    <input
                        type="date"
                        name="expirationDate"
                        id="expirationDate"
                        value={newSupplie.expirationDate || ""}
                        onChange={(e) =>
                            handleChange("expirationDate", e.target.value)
                        }
                        className={`shadow-sm pl-2 w-full bg-white border ${
                            formErrors.expirationDate
                                ? "border-red-500"
                                : "border-gray-300"
                        } focus:ring-primary focus:border-primary sm:text-sm rounded-md block`}
                    />
                    {formErrors.expirationDate && (
                        <p className="mt-2 text-sm text-red-600">
                            {formErrors.expirationDate}
                        </p>
                    )}
                </div>
                <div>
                    <label
                        htmlFor="stock"
                        className="block text-sm font-medium leading-6 text-gray-900"
                    >
                        Stock actual
                        <span className="font-medium text-[#F51515] ml-2">
                            *
                        </span>
                    </label>
                    <input
                        type="number"
                        placeholder="Escribe el stock actual..."
                        name="stock"
                        id="stock"
                        value={newSupplie.stock}
                        onChange={(e) => handleChange("stock", e.target.value)}
                        className={`shadow-sm pl-2 w-full bg-white border ${
                            formErrors.stock
                                ? "border-red-500"
                                : "border-gray-300"
                        } focus:ring-primary focus:border-primary sm:text-sm rounded-md block`}
                    />
                    {formErrors.stock && (
                        <p className="mt-2 text-sm text-red-600">
                            {formErrors.stock}
                        </p>
                    )}
                </div>
                <div>
                    <label
                        htmlFor="unitCost"
                        className="block text-sm font-medium leading-6 text-gray-900"
                    >
                        Costo unitario
                        <span className="font-medium text-[#F51515] ml-2">
                            *
                        </span>
                    </label>
                    <input
                        type="number"
                        step="any"
                        placeholder="Escribe el consto por unidad..."
                        name="unitCost"
                        id="unitCost"
                        value={newSupplie.unitCost}
                        onChange={(e) =>
                            handleChange("unitCost", e.target.value)
                        }
                        className={`shadow-sm pl-2 w-full bg-white border ${
                            formErrors.unitCost
                                ? "border-red-500"
                                : "border-gray-300"
                        } focus:ring-primary focus:border-primary sm:text-sm rounded-md block`}
                    />
                    {formErrors.unitCost && (
                        <p className="mt-2 text-sm text-red-600">
                            {formErrors.unitCost}
                        </p>
                    )}
                </div>
                <SimpleCombobox
                    inputClassName="relative"
                    placeholder={"Seleccione la marca"}
                    handleChange={handleChange}
                    name="brand"
                    label="Marca"
                    className="shadow-sm pl-2 mt-1 w-full bg-white border border-gray-300 focus:ring-primary focus:border-primary block sm:text-sm rounded-md"
                    options={props.brands}
                    create={createBrand}
                    error={formErrors.brand}
                />
                <div>
                    <label
                        htmlFor="observations"
                        className="block text-sm font-medium leading-6 text-gray-900"
                    >
                        Observaciones
                    </label>
                    <textarea
                        name="observations"
                        id="observations"
                        value={newSupplie.observations}
                        onChange={(e) =>
                            handleChange("observations", e.target.value)
                        }
                        className={`shadow-sm pl-2 w-full bg-white border ${
                            formErrors.observations
                                ? "border-red-500"
                                : "border-gray-300"
                        } focus:ring-primary focus:border-primary sm:text-sm rounded-md block`}
                    />
                    {formErrors.observations && (
                        <p className="mt-2 text-sm text-red-600">
                            {formErrors.observations}
                        </p>
                    )}
                </div>
            </div>
            <button
                type="submit"
                className="w-full mt-6 flex justify-center items-center px-4 py-2 border border-transparent shadow-sm text-sm font-semibold rounded-md text-white bg-primary hover:bg-primary"
            >
                Agregar insumo
            </button>
        </form>
    );
};
